import React,{
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./JourneyTimeline.css";

import {

    CheckCircle2,

    Lock,

    Circle

} from "lucide-react";

const JourneyTimeline = () => {

    const email =
        localStorage.getItem(
            "user_email"
        );

    const [currentLevel,setCurrentLevel] =
        useState(1);

    useEffect(()=>{

        loadJourney();

    },[]);

    const loadJourney = async()=>{

        try{

            const res =
            await axios.get(

                `/api/ignite/journey/${email}`

            );

            setCurrentLevel(

                res.data.levelObjectives.currentLevel

            );

        }

        catch(err){

            console.error(err);

        }

    };

    const levels=[

        {

            id:1,

            title:"ROOKIE"

        },

        {

            id:2,

            title:"CONTENDER"

        },

        {

            id:3,

            title:"PERFORMER"

        },

        {

            id:4,

            title:"ELITE"

        }

    ];

    return(

        <div className="journey-timeline-card">

            <h2>

                Journey Timeline

            </h2>

            <p>

                Track your progress through every Ignite level.

            </p>

            <div className="timeline">

                {

                    levels.map(

                        (level,index)=>(

                            <div

                                key={level.id}

                                className="timeline-item"

                            >

                                <div className="timeline-icon">

                                    {

                                        level.id < currentLevel

                                        ?

                                        <CheckCircle2
                                            size={26}
                                            className="completed"
                                        />

                                        :

                                        level.id===currentLevel

                                        ?

                                        <Circle
                                            size={26}
                                            className="current"
                                        />

                                        :

                                        <Lock
                                            size={22}
                                            className="locked"
                                        />

                                    }

                                </div>

                                <div className="timeline-content">

                                    <h3>

                                        Level {level.id}

                                    </h3>

                                    <span>

                                        {level.title}

                                    </span>

                                </div>

                                {

                                    index!==levels.length-1 &&

                                    <div className="timeline-line"/>

                                }

                            </div>

                        )

                    )

                }

            </div>

        </div>

    );

};

export default JourneyTimeline;